import React, { useEffect, useState } from "react";
import { Popover, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import accoArrow from "../../assets/acco_arrow-up.svg";
import accoArrowWhite from "../../assets/WhiteIcons/acco_arrow-upWhite.svg";
import { setWordcloudColour } from "../../redux/actions/WidgetMaker/GraphConfig";
import blackPencilIcon from "../../assets/WidgetMaker/black_pencil_icon.svg";
import whitePencilIcon from "../../assets/WidgetMaker/white_pencil_icon.svg";
import { CheckOutlined } from "@ant-design/icons";
import { setWidgetMakerApiCallFlag } from "../../redux/actions/WidgetMaker/WidgetMaker";
import { getPaneIndex } from "../../redux/constants";
import sentimentColorImg from "../../assets/wordcloud_sentiment_color_img.svg";
import multipleColorImg from "../../assets/wordcloud_multiple_color_img.svg";
import { setWordcloudColourInDeepDiveDashboard } from "../../redux/actions/DeepDiveDashboard/DeepDiveDashboard";

const globalChartColor = [
  "#3076F7",
  "#9D48FF",
  "#60E340",
  "#FFB940",
  "#3FE7AC",
  "#FF6E31",
  "#8397F1",
  "#2968B9",
  "#00A669",
  "#FF7D6C",
  "#1C9F00",
  "#A77B00",
  "#FF4343",
  "#FF2EF2",
  "#B600AA",
  "#D19C00",
  "#39A7E4",
  "#6600DA",
  "#FFC1B9",
  "#FF9C73",
  "#FFD58B",
  "#96FF7C",
  "#6A8CFD",
  "#FF83F7",
  "#CD97FF",
  "#FFBE00",
  "#E84500",
  "#19CDCE",
  "#EF2E2E",
];

const WordCloudColorPalate = ({
  section_index,
  widget_index,
  widgetData,
  template_widget,
  type,
  onChangeSeriesColor,
  seriesColor,
}) => {
  const dispatch = useDispatch();
  const authParams = useSelector((state) => state.Authentication.authParams);
  const panes = useSelector((state) => state.Tab1.panes);
  const activeKey = useSelector((state) => state.Tab1.activeKey);
  const Section = useSelector((state) => state.Section.addSection);
  let index = getPaneIndex(panes, activeKey);
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );
  const widgetGraphConfig = useSelector(
    (state) => state?.GraphConfig?.widgetGraphConfig
  );
  const screen = useSelector((state) => state?.Screens?.screen);
  const graphConditions = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  let commonCondition = widgetData
    ? widgetData?.chart?.chart_settings?.wordcloud_color
      ? widgetData?.chart?.chart_settings?.wordcloud_color
      : "0"
    : type === "editField"
    ? seriesColor
      ? seriesColor
      : globalChartColor?.[0]
    : widgetGraphConfig?.chart_settings?.wordcloud_color;

  const [visible, setVisible] = useState(false);
  const [color, setColor] = useState(
    commonCondition ? commonCondition : "black"
  );

  const handleVisibleChange = (newVisible) => {
    setVisible(newVisible);
  };

  const handleChangeColor = (value) => {
    let pathName = window.location.pathname?.split("/")?.[1];
    if (
      ((pathName === "dashboard" || pathName === "pin-dashboard") &&
        !panes?.[index]?.is_widget_maker_open_obj?.open_flag &&
        panes?.[index]?.isDeepDiveDashboard) ||
      shareTemplateData?.isDeepDiveDashboard ||
      screen?.isDeepDiveDashboard
    ) {
      // deep dive dashboard
      if (widgetData) {
        dispatch(
          setWordcloudColourInDeepDiveDashboard(
            value,
            section_index,
            widget_index,
            true
          )
        );
      }
    } else if (
      !panes?.[index]?.is_widget_maker_open_obj?.open_flag &&
      (pathName === "dashboard" || pathName === "pin-dashboard") &&
      type !== "editField"
    ) {
      // view dashboard
      let updatedChartSettings = {
        ...widgetData?.chart?.chart_settings,
        wordcloud_color: value,
      };

      if (widgetData) {
        let updatePanes = [...panes];
        if (section_index >= 0) {
          updatePanes[index].sections[section_index].widgets[
            widget_index
          ].chart.chart_settings = updatedChartSettings;
          if (widgetData?.graphData) {
            updatePanes[index].sections[section_index].widgets[
              widget_index
            ].graphData = null;
          }
          if (widgetData?.persist_graphdata) {
            updatePanes[index].sections[section_index].widgets[
              widget_index
            ].persist_graphdata = null;
          }
          if (widgetData?.deep_dive_on) {
            updatePanes[index].sections[section_index].widgets[
              widget_index
            ].deep_dive_on = null;
          }
        } else {
          updatePanes[index].section[0].widgets[
            widget_index
          ].chart.chart_settings = updatedChartSettings;
          if (widgetData?.graphData) {
            updatePanes[index].section[0].widgets[widget_index].graphData =
              null;
          }
          if (widgetData?.persist_graphdata) {
            updatePanes[index].section[0].widgets[
              widget_index
            ].persist_graphdata = null;
          }
          if (widgetData?.deep_dive_on) {
            updatePanes[index].section[0].widgets[widget_index].deep_dive_on =
              null;
          }
        }
        dispatch({ type: "SET_WIDGET_GRAPH_DATA", panes: updatePanes });
      }
    } else if (
      (pathName === "edit-dashboard" || pathName === "create-dashboard") &&
      type !== "editField"
    ) {
      // edit and create
      let updatedChartSettings = {
        ...widgetData?.chart?.chart_settings,
        wordcloud_color: value,
      };

      if (widgetData) {
        let updatedSection = [...Section];
        if (section_index >= 0) {
          updatedSection[section_index].data[
            widget_index
          ].chart.chart_settings = updatedChartSettings;
          if (widgetData?.data) {
            updatedSection[section_index].data[widget_index].data = null;
          }
        } else {
          updatedSection[0].data[widget_index].chart.chart_settings =
            updatedChartSettings;
          if (widgetData?.data) {
            updatedSection[0].data[widget_index].data = null;
          }
        }
        dispatch({ type: "SET_ADDSECTION", payload: updatedSection });
      }
    } else if (shareTemplateData && type !== "editField") {
      // share dashboard
      let updatedChartSettings = {
        ...widgetData?.chart?.chart_settings,
        wordcloud_color: value,
      };

      if (widgetData) {
        let updateShareTemplateData = { ...shareTemplateData };
        if (section_index >= 0) {
          updateShareTemplateData.sections[section_index].widgets[
            widget_index
          ].chart.chart_settings = updatedChartSettings;
          if (widgetData?.graphData) {
            updateShareTemplateData.sections[section_index].widgets[
              widget_index
            ].graphData = null;
          }
          if (widgetData?.persist_graphdata) {
            updateShareTemplateData.sections[section_index].widgets[
              widget_index
            ].persist_graphdata = null;
          }
          if (widgetData?.deep_dive_on) {
            updateShareTemplateData.sections[section_index].widgets[
              widget_index
            ].deep_dive_on = null;
          }
        } else {
          updateShareTemplateData.section[0].widgets[
            widget_index
          ].chart.chart_settings = updatedChartSettings;
          if (widgetData?.graphData) {
            updateShareTemplateData.section[0].widgets[widget_index].graphData =
              null;
          }
          if (widgetData?.persist_graphdata) {
            updateShareTemplateData.section[0].widgets[
              widget_index
            ].persist_graphdata = null;
          }
          if (widgetData?.deep_dive_on) {
            updateShareTemplateData.section[0].widgets[
              widget_index
            ].deep_dive_on = null;
          }
        }
        dispatch({
          type: "SET_SHARE_TEMPLATE_DATA",
          payload: updateShareTemplateData,
        });
      }
    } else {
      // Widget Maker Case
      // console.log("value data =>", value);
      // setting color from edit Panel
      if (type === "editField") {
        if (typeof onChangeSeriesColor === "function") {
          if (value !== "0" || value !== "1") {
            setColor(value);
          }
          onChangeSeriesColor(value);
          setVisible(false);
        }
      } else {
        if (
          value !== "1" &&
          widgetGraphConfig?.chart_settings?.wordcloud_color !== "1"
        ) {
          // do not call api in case of not sentiment color
          dispatch(setWidgetMakerApiCallFlag(true));
        }
        dispatch(setWordcloudColour(value, widgetGraphConfig));
        if (value !== "0" || value !== "1") {
          setColor(value);
        }
      }
    }
  };
  useEffect(() => {
    if (seriesColor) {
      setColor(seriesColor);
    }
  }, [seriesColor]);

  return (
    <div>
      <Popover
        content={
          <>
            <div
              style={{
                // maxHeight: "22rem",
                width: "19rem",
              }}
            >
              {type !== "editField" ? (
                <div
                  onClick={() => handleChangeColor("0")}
                  className="text_regular text-ellipsis cursor-pointer"
                  style={{
                    padding: "0.5rem",
                    background: commonCondition === "0" ? "#E6F7FF" : "",
                    fontWeight: commonCondition === "0" ? "500" : "",
                  }}
                >
                  Multiple Colour
                </div>
              ) : (
                ""
              )}

              {graphConditions?.[`wordcloud-hide-unhide`]?.includes(
                widgetGraphConfig?.x_axis?.attribute ||
                  widgetData?.x_axis?.attribute
              ) && type !== "editField" ? (
                <div
                  onClick={() => handleChangeColor("1")}
                  className="text_regular text-ellipsis cursor-pointer"
                  style={{
                    padding: "0.5rem",
                    background: commonCondition === "1" ? "#E6F7FF" : "",
                    fontWeight: commonCondition === "1" ? "500" : "",
                  }}
                >
                  Sentiment Colour
                </div>
              ) : (
                ""
              )}
              <div
                // onClick={() => handleChangeColor("Solid Colour")}
                className="text_regular text-ellipsis"
                style={{
                  padding: "0.5rem",
                  background:
                    commonCondition !== "0" && commonCondition !== "1"
                      ? "#E6F7FF"
                      : "",
                  fontWeight:
                    commonCondition !== "0" && commonCondition !== "1"
                      ? "500"
                      : "",
                }}
              >
                Solid Colour &nbsp;
                <div className="row wordcloud-color-row">
                  {globalChartColor &&
                    globalChartColor?.map((d) => {
                      return (
                        <div className="col-2">
                          <div
                            className="wordcloud-color-col"
                            onClick={() => handleChangeColor(d)}
                            style={{
                              backgroundColor: d,
                            }}
                          ></div>
                          {d === commonCondition ? (
                            <CheckOutlined className="wordcloud-color-check-icon" />
                          ) : (
                            ""
                          )}
                        </div>
                      );
                    })}
                  <div className="wordcloud-color-pencil-div">
                    <img
                      src={
                        authParams?.theme_type === "1"
                          ? whitePencilIcon
                          : blackPencilIcon
                      }
                      alt="Color Picker Icon"
                      style={{
                        width: "1.8rem",
                      }}
                      className="mr-2"
                    />
                    <input
                      className="wordcloud-color-pencil-input cursor-pointer"
                      type="color"
                      onChange={(e) => handleChangeColor(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </>
        }
        title={null}
        trigger="click"
        open={visible}
        onOpenChange={handleVisibleChange}
        placement="bottomLeft"
        overlayClassName={
          authParams?.theme_type === "1"
            ? "darkTheme brandsdropdown"
            : "lightTheme brandsdropdown"
        }
      >
        <div
          style={{
            marginLeft: type === "dashboard" ? "1rem" : "",
            padding: type === "dashboard" ? "0.3rem 1.2rem" : "0.8rem 1.2rem",
            borderRadius: type === "dashboard" ? "0.6rem" : "0.4rem",
            minWidth: widgetData?.span === "one_third" ? "6rem" : "19rem",
          }}
          className={`border-color border text_regular cursor-pointer d-flex align-items-center justify-content-between`}
          onClick={(e) => e.preventDefault()}
        >
          {/* {widgetData?.span !== "one_third" &&
          commonCondition !== "0" &&
          commonCondition !== "1" ? (
            <>
              <div
                style={{
                  width: "1.8rem",
                  height: "1.8rem",
                  borderRadius: "0.3rem",
                  backgroundColor: color && color,
                }}
              ></div>
            </>
          ) : (
            ""
          )} */}
          <div>
            {widgetData?.span === "one_third" ? (
              commonCondition === "0" ? (
                <Tooltip title="Multiple Colour">
                  <img src={multipleColorImg} />
                </Tooltip>
              ) : commonCondition === "1" ? (
                <Tooltip title="Sentiment Colour">
                  <img src={sentimentColorImg} />
                </Tooltip>
              ) : (
                <Tooltip title="Solid Colour">
                  <div
                    style={{
                      marginTop: "0.4rem",
                      marginBottom: "0.4rem",
                      width: "1.5rem",
                      height: "1.5rem",
                      borderRadius: "0.3rem",
                      backgroundColor: color && color,
                    }}
                  ></div>
                </Tooltip>
              )
            ) : commonCondition === "0" ? (
              <>
                <Tooltip title="Multiple Colour">
                  <img
                    src={multipleColorImg}
                    style={{ marginRight: "0.5rem" }}
                  />
                  Multiple Colour
                </Tooltip>
              </>
            ) : commonCondition === "1" ? (
              <>
                <Tooltip title="Sentiment Colour">
                  <img
                    src={sentimentColorImg}
                    style={{ marginRight: "0.5rem" }}
                  />
                  Sentiment Colour
                </Tooltip>
              </>
            ) : (
              <Tooltip title="Solid Colour">
                <span className="d-flex">
                  <div
                    style={{
                      marginRight: "0.5rem",
                      marginTop: "0.4rem",
                      marginBottom: "0.4rem",
                      width: "1.5rem",
                      height: "1.5rem",
                      borderRadius: "0.3rem",
                      backgroundColor: color && color,
                    }}
                  ></div>
                  <span style={{ alignSelf: "center" }}>Solid Colour</span>
                </span>
              </Tooltip>
            )}
          </div>

          <img
            src={authParams?.theme_type === "1" ? accoArrowWhite : accoArrow}
            className="accordionArrow p-0"
            alt="arrow"
          />
        </div>
      </Popover>
    </div>
  );
};

export default WordCloudColorPalate;
